import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  FormControlLabel,
  Switch,
  FormHelperText,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../../../components/loader/Loader";
import { yupResolver } from "@hookform/resolvers/yup";
import { citySchema } from "../../../app/schema";
import { Controller, useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import { FormInputText } from "../../../components/form-components/FormInputText";
// import { useAdmin } from "../../../components/Admin/Admin";
import { useDispatch } from "react-redux";
import { showConfirmModal, showModal } from "../../../redux/counterSlice";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { grey, red } from "@mui/material/colors";

function DeliveryCharges() {
  const dispatch = useDispatch();
  const methods = useForm({
    resolver: yupResolver(citySchema),
  });
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { id } = useParams();
  // const { admin } = useAdmin();

  // Load data from API
  const loadInitialData = async () => {
    setLoader(true);
    try {
      const res = await axios.get("/getDeliveryCharge");
      setFormData(res.data?.data || []);
    } catch (err) {
      toast.error(err?.message || "Failed to load data");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadInitialData();
    }
  }, [id]);

  // Reset form whenever selectedRow changes
  useEffect(() => {
    if (selectedRow) {
      reset(selectedRow);
    } else {
      reset({
        distance_from: "",
        distance_to: "",
        rate: "",
        cgst: "",
        sgst: "",
        free_delivery: false,
      });
    }
  }, [selectedRow, reset]);

  const deleteClickHandler = async (region_id) => {
    setLoader(true);
    try {
      if (region_id) {
        const response = await axios.get("/deleteDelivery/" + region_id);
        if (!response?.data?.error) {
          toast.success(response?.data?.message);
          loadInitialData();
          setOpen(false);
          setSelectedRow(null);
          reset();
        } else {
          let errDesc = "";
          if (response?.data?.data) {
            Object.values(response.data.data).forEach((error) => {
              errDesc += error + "\n ";
            });
          } else {
            errDesc = response?.data?.message;
          }

          dispatch(
            showModal({
              msg: errDesc,
              error: response?.data?.error,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
    } finally {
      setLoader(false);
      setOpen(false);
    }
  };

  // const columns = [
  //   {
  //     name: "id",
  //     label: "S. No",
  //     options: {
  //       customBodyRenderLite: (dataIndex) => <p>{dataIndex + 1}</p>,
  //     },
  //   },
  //   {
  //     name: "region_id",
  //     label: "Region ID",
  //   },
  //   {
  //     name: "location_name",
  //     label: "Location",
  //     options: {
  //       customBodyRenderLite: (dataIndex) => (
  //         <p>{filteredData[dataIndex]?.location?.location_name || "-"}</p>
  //       ),
  //     },
  //   },
  //   {
  //     name: "distance_from",
  //     label: "Distance From",
  //     options: {
  //       customBodyRenderLite: (dataIndex) => {
  //         const val = filteredData[dataIndex]?.distance_from;
  //         return val != null ? `${Math.round(val)} km` : "-";
  //       },
  //     },
  //   },
  //   {
  //     name: "distance_to",
  //     label: "Distance To",
  //     options: {
  //       customBodyRenderLite: (dataIndex) => {
  //         const val = filteredData[dataIndex]?.distance_to;
  //         return val != null ? `${Math.round(val)} km` : "-";
  //       },
  //     },
  //   },
  //   {
  //     name: "Actions",
  //     options: {
  //       customBodyRenderLite: (dataIndex) => {
  //         const status = formData[dataIndex]?.active_status;
  //         return (
  //           <div className="actionBtns">
  //             <Button
  //               disabled={status === 1}
  //               aria-label="delete"
  //               onClick={() => {
  //                 dispatch(
  //                   showConfirmModal({
  //                     msg: "delete",
  //                     action: () =>
  //                       deleteClickHandler(formData[dataIndex]?.region_id),
  //                   })
  //                 );
  //               }}
  //             >
  //               <DeleteOutlineOutlinedIcon
  //                 sx={{ color: status === 1 ? grey[600] : red[500] }}
  //                 fontSize="medium"
  //               />
  //             </Button>
  //           </div>
  //         );
  //       },
  //     },
  //   },
  // ];
  const columns = [
    {
      name: "id",
      label: "S. No",
      options: {
        customBodyRenderLite: (dataIndex) => <p>{dataIndex + 1}</p>,
      },
    },
    {
      name: "region_id",
      label: "Region ID",
    },
    {
      name: "location_name",
      label: "Location",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <p>{filteredData[dataIndex]?.location?.location_name || "-"}</p>
        ),
      },
    },
    {
      name: "origin_addresses",
      label: "Origin Address",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <p>{filteredData[dataIndex]?.origin_addresses || "-"}</p>
          //         const val = filteredData[dataIndex]?.origin_addresses;
          //         return val != null ? `${Math.round(val)} km` : "-";
        ),
      },
    },
    {
      name: "destination_addresses",
      label: "Destination Address",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <p>{filteredData[dataIndex]?.destination_addresses || "-"}</p>
          //         const val = filteredData[dataIndex]?.destination_addresses;
          //         return val != null ? `${Math.round(val)} km` : "-";
        ),
      },
    },
    {
      name: "distance",
      label: "Distance (m)",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <p>{filteredData[dataIndex]?.distance || "-"}</p>
        ),
      },
    },
    {
      name: "rate_gst_total",
      label: "Total GST",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <p>{filteredData[dataIndex]?.rate_gst_total || "-"}</p>
        ),
      },
    },
    {
      name: "Actions",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const status = formData[dataIndex]?.active_status;
          return (
            <div className="actionBtns">
              <Button
                disabled={status === 1}
                aria-label="delete"
                onClick={() => {
                  dispatch(
                    showConfirmModal({
                      msg: "delete",
                      action: () =>
                        deleteClickHandler(formData[dataIndex]?.region_id),
                    })
                  );
                }}
              >
                <DeleteOutlineOutlinedIcon
                  sx={{ color: status === 1 ? grey[600] : red[500] }}
                  fontSize="medium"
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  const filteredData = useMemo(() => {
    return formData.filter((item) => Number(item.region_id) === Number(id));
  }, [formData, id]);

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    reset();
  };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      country_id: 101,
    };
    saveForm(payload);
  };

  const saveForm = async (data) => {
    setLoader(true);
    try {
      let response;
      if (selectedRow?.region_id) {
        response = await axios.post("/updateDelivery", {
          ...data,
          region_id: selectedRow.region_id,
        });
      } else {
        response = await axios.post("/createDelivery", data);
      }

      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        loadInitialData();
        setOpen(false);
        setSelectedRow(null);
        reset();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response.data.data).forEach((error) => {
            errDesc += error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
    } finally {
      setLoader(false);
    }
  };

  // const CreateEditDialog = React.memo(() => (
  //   <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
  //     <DialogTitle className="text-primary">
  //       {selectedRow ? "Edit Delivery" : "New Delivery"}
  //     </DialogTitle>
  //     <DialogContent>
  //       <Grid container columnSpacing={{ xs: 5 }}>
  //         <Grid item xs={6}>
  //           <FormInputText
  //             name="distance_from"
  //             control={control}
  //             label="Distance From"
  //             errors={errors}
  //             mandatory="true"
  //           />
  //         </Grid>
  //         <Grid item xs={6}>
  //           <FormInputText
  //             name="distance_to"
  //             control={control}
  //             label="Distance To"
  //             errors={errors}
  //             mandatory="true"
  //           />
  //         </Grid>
  //         <Grid item xs={12}>
  //           <FormInputText
  //             name="rate"
  //             control={control}
  //             label="Rate"
  //             errors={errors}
  //             mandatory="true"
  //           />
  //         </Grid>
  //         <Grid item xs={6}>
  //           <FormInputText
  //             name="cgst"
  //             control={control}
  //             label="CGST"
  //             errors={errors}
  //             mandatory="true"
  //           />
  //         </Grid>
  //         <Grid item xs={6}>
  //           <FormInputText
  //             name="sgst"
  //             control={control}
  //             label="SGST"
  //             errors={errors}
  //             mandatory="true"
  //           />
  //         </Grid>
  //         <Grid item xs={12}>
  //           <Controller
  //             name="free_delivery"
  //             control={control}
  //             defaultValue={false}
  //             render={({ field }) => (
  //               <>
  //                 <FormControlLabel
  //                   className="w-100"
  //                   control={
  //                     <Switch
  //                       {...field}
  //                       checked={field.value}
  //                       onChange={(e) => field.onChange(e.target.checked)}
  //                     />
  //                   }
  //                   label="Free Delivery"
  //                 />
  //                 {errors.free_delivery && (
  //                   <FormHelperText error>
  //                     {errors.free_delivery.message}
  //                   </FormHelperText>
  //                 )}
  //               </>
  //             )}
  //           />
  //         </Grid>
  //       </Grid>
  //     </DialogContent>
  //     <DialogActions>
  //       <Button onClick={handleClose} variant="contained" color="error">
  //         Cancel
  //       </Button>
  //       <Button
  //         color="primary"
  //         variant="contained"
  //         onClick={handleSubmit(onSubmit)}
  //         startIcon={<SaveIcon />}
  //       >
  //         Save
  //       </Button>
  //     </DialogActions>
  //   </Dialog>
  // ));
  const CreateEditDialog = React.memo(() => (
    <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
      <DialogTitle className="text-primary">
        {selectedRow ? "Edit Delivery" : "New Delivery"}
      </DialogTitle>
      <DialogContent>
        <Grid container columnSpacing={{ xs: 5 }}>
          <Grid item xs={12}>
            <FormInputText
              name="origin_addresses"
              control={control}
              label="Origin Address"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={12}>
            <FormInputText
              name="destination_addresses"
              control={control}
              label="Destination Address"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="distance"
              control={control}
              label="Distance (m)"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="rate"
              control={control}
              label="Rate"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="cgst"
              control={control}
              label="CGST (%)"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="sgst"
              control={control}
              label="SGST (%)"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={6}>
            <FormInputText
              name="rate_gst_total"
              control={control}
              label="Total GST"
              errors={errors}
              mandatory="true"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="free_delivery"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <>
                  <FormControlLabel
                    className="w-100"
                    control={
                      <Switch
                        {...field}
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="Free Delivery"
                  />
                  {errors.free_delivery && (
                    <FormHelperText error>
                      {errors.free_delivery.message}
                    </FormHelperText>
                  )}
                </>
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  ));

  const options = {
    selectableRows: "none",
    filter: false,
    download: true,
    viewColumns: false,
    print: false,
  };

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <>
          <h4>Delivery Charges</h4>
          <MUIDataTable
            data={filteredData}
            columns={columns}
            options={options}
            title={
              // admin?.user_name === "bfadmin" && (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setSelectedRow(null); // Clear for new delivery
                    setOpen(true);
                    reset(); // reset form fields
                  }}
                  startIcon={<AddIcon />}
                >
                  New Delivery
                </Button>
              // )
            }
          />
          <CreateEditDialog />
        </>
      )}
    </div>
  );
}

export default DeliveryCharges;
